import { unwrapResult } from '@reduxjs/toolkit'
import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'

import { useActionRunner } from 'src/modules/notification'

import { useProducts } from '../hooks'
import ProductForm from './ProductForm'

const EditProduct = ({ match }) => {
  const { id } = match.params
  const history = useHistory()

  const {
    editProduct,
    fetchSingleProduct,
    product,
    productOptions,
  } = useProducts()

  const {
    allergens,
    categories,
    dietary,
    nutritional,
    sustainability,
  } = productOptions

  const [doFetchSingleProduct, isFetching] = useActionRunner(
    fetchSingleProduct,
    {
      initialFetchingState: true,
    }
  )

  const [doEditProduct] = useActionRunner(editProduct, {
    successNotification: 'Product updated!',
  })

  const handleSubmit = async values => {
    const result = await doEditProduct({ id, params: values })
    try {
      unwrapResult(result)
      history.push(`/products`)
    } catch (error) {}
    return result
  }

  useEffect(() => {
    doFetchSingleProduct(id)
  }, [])

  if (isFetching) {
    return null
  }

  return (
    <ProductForm
      allergenOptions={allergens}
      categoryOptions={categories}
      dietaryOptions={dietary}
      nutritionalOptions={nutritional}
      onSubmit={handleSubmit}
      product={product}
      sustainabilityOptions={sustainability}
      title="Edit Product"
    />
  )
}

export default EditProduct
